import { NewContract } from '@vae/server/dist/client'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DateInput from '../../../components/inputs/DateInput'

const MoveOrChangeStep: React.FC<{
	contract: Partial<NewContract>
	setContract: (key: keyof NewContract, value: string | number) => void
	minDate?: string
	maxDate?: string
}> = ({ contract, setContract, minDate, maxDate }) => {
	const dateFormat = 'YYYY-MM-DD'

	const { t } = useTranslation('modals_createContract', { keyPrefix: 'moveOrChangeStep' })

	const onBlur = (value: string) => {
		const setEndDate = dayjs(value)
		const maxDate = dayjs().add(90, 'day')
		const isAfter = setEndDate.isAfter(dayjs().add(90, 'day'))

		if (isAfter) {
			return setContract('contractStartDate', maxDate.format(dateFormat))
		}

		return setContract('contractStartDate', dayjs(value).format(dateFormat))
	}

	return (
		<div className='container'>
			<span className='text-text-dark dark:text-white'>{t('disclaimer')}</span>
			<DateInput
				onChange={v => setContract('contractStartDate', dayjs(v).format(dateFormat))}
				onBlur={onBlur}
				value={contract?.contractStartDate}
				label={t('startDate')}
				maxDate={maxDate ?? dayjs().add(90, 'days').format(dateFormat)}
				minDate={minDate ?? dayjs().add(15, 'days').format(dateFormat)}
			/>
		</div>
	)
}

export default MoveOrChangeStep
